import * as Yup from 'yup';

import { Hierarchy } from 'src/constants';

export const PartnerTypeValidation = Yup.string()
    .oneOf(Object.values(Hierarchy))
    .required('Select Partner Type');

export const step1ValidationSchema = Yup.object().shape({
    partnerType: PartnerTypeValidation,
    topLevelPartner: Yup.string().when('partnerType', {
        is: (partnerType: string) => {
            return partnerType === Hierarchy.PARTNER_OF_PARTNER;
        },
        then: Yup.string().required('Select Partner').nullable(),
    }),
    country: Yup.string().required('Select Country'),
});
